import React from 'react';
import '../App.css';

function CTASection() {
  return (
    <section className="section cta" aria-label="cta" >
      <div className="container">
        <h2 className="h2 section-title">Quality Assurance</h2>
        <p className="cta-subtitle">We pride ourselves on delivering excellence. Every project at Leyaa Hub undergoes rigorous quality checks to ensure that our clients receive not just a service, but a solution that adds tangible value to their endeavors.</p>
      </div>
    </section>
  );
}

export default CTASection;
